import React from "react";
import { CalendarClockIcon, FileQuestionIcon, MessageSquareOffIcon, SignpostIcon } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { problems } from "../data/landing";
const icons = [CalendarClockIcon, FileQuestionIcon, MessageSquareOffIcon, SignpostIcon];
export function ProblemSection() {
  return <section className="bg-white py-16 md:py-24" data-id="element-97" data-mp="2vowm4nmmeb2j">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-98" data-mp="39hm84s25ffzn">
        <SectionHead eyebrow="The request is simple. The prep isn't." title="Sound" highlight="familiar?" data-id="element-99" data-mp="39g2tf5w55czz" />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-100" data-mp="35iddzm375g3k">
          {problems.map((problem, i) => {
          const Icon = icons[i];
          return <article key={problem.title} className="flex gap-5 rounded-xl border border-line bg-white p-6 shadow-[0_10px_30px_rgba(19,34,56,0.06)] md:p-7" data-id="element-101" data-mp="3eiaauazqpl9p" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-teal-wash" data-id="element-102" data-mp="1k498vh8w8i5e">
                  <Icon className="h-6 w-6 text-teal" aria-hidden="true" data-id="element-103" data-mp="jeyag7urmdy5" />
                </span>
                <div data-id="element-104" data-mp="ocg8v4b5parw">
                  <h3 className="font-display text-2xl font-bold uppercase leading-tight text-navy" data-id="element-105" data-mp="o9u0j2gfyr8m">{problem.title}</h3>
                  <p className="mt-2 text-[15px] text-ink/80" data-id="element-106" data-mp="x49uv69gfdov">{problem.text}</p>
                </div>
              </article>;
        })}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold uppercase text-navy sm:text-3xl" data-id="element-107" data-mp="123cwegq871s3">
          You don't need more time. <span className="text-teal" data-id="element-108" data-mp="1c227nqnm9nzd">You need a starting point.</span>
        </p>
      </div>
    </section>;
}